export default __webpack_public_path__ + "static/media/pexels-tima-miroshnichenko-8376152.6d183ab0.jpg";